import React, { useEffect }  from "react"
import styled from 'styled-components'

import OurWorkSlider from './our-work-slider'
import OurClientsSlider from "./our-clients-slider"

import GrayDots from '../../images/gray-halftone-dots.svg'

import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const OurWork = () => {

    useEffect(() => {

        if (typeof window !== `undefined`) {
            gsap.registerPlugin(ScrollTrigger)
            gsap.core.globals('ScrollTrigger', ScrollTrigger)
        }

        ScrollTrigger.matchMedia({

            "(min-width: 1200px)": function() {

                // Our Work Entrance
                let tlEcTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#our_work_animate",
                        start: 'top 80%',
                        end: 'top 80%',
                        id: 'our_work_animate',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlEcTwo.to('.our-work-title-bar', { duration: 1, left: '0' }, 0)
                tlEcTwo.to('.ow-title-h2', { duration: 1, right: '150px' }, 0.4)
                tlEcTwo.to('.our-work-slider', { duration: .5, opacity: '1', top: '0' }, 0.5)
            }

        });
    
    }, []);

    return(
        <MainSection id="our_work_animate">
            <div class="our-work-title-bar">
                <div class="ow-title-box">
                    <h2 class="ow-title-h2">Our Clients & Work</h2>
                </div>
            </div>
            <div class="our-work-slider">
                <OurClientsSlider />
            </div>
            <div class="our-work-slider">
                <OurWorkSlider />
            </div>
        </MainSection>
    );

}

const MainSection = styled.section`
    width: 100%;
    overflow: hidden;
    margin-bottom: 100px;
    .our-work-title-bar {
        max-width: 1310px;
        width: 100%;
        margin: 0px auto;
        margin-bottom: 100px;
        padding: 0 20px;
        padding-top: 120px;
        position: relative;
        left: -150%;
        &:before {
            content: '';
            position: absolute;
            height: calc(100% - 120px);
            width: 200%;
            top: 120px;
            left: calc(-200% + 20px);
            background-color: #C44C4A;
        }
        .ow-title-box {
            width: 100%;
            height: 150px;
            padding-right: 150px;
            position: relative;
            background-color: #C44C4A;
            &:before {
                content: '';
                position: absolute;
                top: -120px;
                right: 55px;
                height: 120px;
                width: 200%;
                background-image: url(${GrayDots});
                background-size: 10%;
            }
        }
        h2 {
            position: absolute;
            font-family: "Work Sans";
            font-size: 50px;
            line-height: 150px;
            font-weight: 700;
            letter-spacing: 3px;
            color: #fff;
            text-transform: uppercase;
            margin-top: 0;
            margin-bottom: 0;
            right: -100%;
        }
    }
    .our-work-slider {
        width: 100%;
        top: 20px;
        opacity: 0;
    }
    @media(max-width: 1200px) {
        .our-work-title-bar {
            left: auto !important;
            .ow-title-box {
                &:before {
                    background-size: 20%;
                }
            }
            h2 {
                right: 150px !important;
            }
        }
        .our-work-slider {
            top: 0 !important;
            opacity: 1 !important;
        }
    }
    @media(max-width: 767px) {
        .our-work-title-bar {
            .ow-title-box {
                padding-right: 0;
                &:before {
                    background-size: 40%;
                }
            }
            h2 {
                position: relative;
                right: auto !important;
                text-align: center;
                font-size: 24px;
            }
        }
    }
`

export default OurWork